
const PublicView = () => import("@views/app/public/public-view.vue");
const DocumentationVerificationView = () => import("@views/app/public/documentation-verification-view.vue");
const PublicFailView = () => import("@views/app/public/public-fail-view.vue");
const EmailVerificationView = () => import("@views/app/public/email-verification-view.vue");
const DocumentationSubmitView = () => import("@views/app/public/documentation-submit-view.vue");
const DocumentationSuccessView = () => import("@views/app/public/documentation-success-view.vue");
const ProformaPaymentView = () => import("@/app/views/app/contract-create/proforma-payment-view.vue");
const PasswordResetSetView = () => import("@/app/views/app/contract-create/password-reset-set-view.vue");
const PasswordResetEndSuccess = () => import("@/app/views/app/contract-create/password-reset-end-success.vue");
const IdentificationSelectionView = () => import("@/app/views/app/public/identification-selection-view.vue");
const RekonoIdentificationStartView = () => import("@/app/views/app/public/identification-rekono-start-view.vue");
const RekonoIdentificationView = () => import("@/app/views/app/public/identification-rekono-view.vue");
const RekonoIdentificationSuccessView = () => import("@/app/views/app/public/identification-rekono-success-view.vue");
const RekonoIdentificationFailView = () => import("@/app/views/app/public/identification-rekono-fail-view.vue");
const PostIdentificationView = () => import("@/app/views/app/public/post-identification-view.vue");
const FinApiSuccessView = () => import("@/app/views/app/public/fin-api-success-view.vue");
const FinApiFailView = () => import("@/app/views/app/public/fin-api-fail-view.vue");
const FinApiFinishedView = () => import("@/app/views/app/public/fin-api-finished-view.vue");

const PostIdentificationSuccessView = () => import("@/app/views/app/public/post-identification-success-view.vue");
const EmptyComponent = { template: "<div></div>" }

export const publicRoutes = [
    {
        component: PublicView,
        name: "public",
        path: "public",
        children: [
            {
                // popraviti na VerificationPhone, ko bo komponenta
                component: ProformaPaymentView,
                name: "ProformaPayment",
                path: "proforma-payment/:dobType?",
                props: true,
                meta: {
                    buttons: [
                        // prva 2 gumba dati stran, ko bo komponenta
                        { name: "Next", action: "webNext", visible: true },
                    ],
                    navigation: { nextStep: "WebOrderStep1", endFail: "EndFail" },
                },            
            },
            {
                component: DocumentationVerificationView,
                name: "DocumentationVerification",
                path: "documentation/verification/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "SendPin", action: "sendPinCode", visible: true },
                        { name: "ConfirmPin", action: "confirmPinCode", visible: true },
                    ],
                    navigation: { 
                        endFail: "PublicEndFail",
                        DocumentationSubmit: "DocumentationSubmit"
                    },
                },
            },
            {
                component: DocumentationSubmitView,
                name: "DocumentationSubmit",
                path: "documentation/submit/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "uploadDocumentation", visible: true }
                    ],
                    navigation: { 
                        endFail: "PublicEndFail",
                        nextStep: "DocumentationEndSuccess",
                        endFailFinApi: "FinApiEndFail",
                        nextStepFinApi: "FinApiEndSuccess"
                    },
                },
            },
            {
                component: DocumentationSuccessView,
                name: "DocumentationEndSuccess",
                path: "documentation/success",
                meta: {
                    buttons: [
                    ],
                },  
            },   
            {
                component: PublicFailView,
                name: "PublicEndFail",
                path: "fail",
                meta: {
                    buttons: [
                    ],
                },  
            },
            {
                component: FinApiFailView,
                name: "FinApiEndFail",
                path: "finapi-fail",
                meta: {
                    buttons: [
                    ]
                },  
            },
            {
                component: FinApiSuccessView,
                name: "FinApiEndSuccess",
                path: "finapi-success",
                meta: {
                    buttons: [
                    ],
                    navigation: { 
                        backToDocumentation: "DocumentationSubmit"
                    },
                },
            },
            {
                component: FinApiFinishedView,
                name: "FinApiFinished",
                path: "finapi-finished",
                meta: {
                    buttons: [
                    ]
                },  
            },
            {
                component: EmailVerificationView,
                name: "EmailVerification",
                path: "email-verify/:flowType/:id",
                meta: {
                    buttons: [
                        { name: "Next", action: "nextStep", visible: true },
                    ],
                    navigation: { webStart: "WebOrderStep3", limitStart: "LimitLogin", endFail: "PublicEndFail", end: "ProcessEndScreen" },
                    //navigation: { webStart: "Login", limitStart: "LimitLogin", endFail: "PublicEndFail", end: "ProcessEndScreen" },
                },            
            },
            {
                component: PasswordResetSetView,
                name: "PasswordResetSet",
                path: "password/reset/set/:flowType/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "SetPassword", action: "nextStep", visible: true },
                    ],
                    navigation: { 
                        endFail: "PublicEndFail",
                        endSuccess: "PasswordResetEndSuccess" 
                    },
                },            
            },
            {
                component: PasswordResetEndSuccess,
                name: "PasswordResetEndSuccess",
                path: "password/reset/success",
                props: true,
                meta: {
                    buttons: [
                        { name: "PasswordResetSuccess", action: "toContractCreate", visible: true },
                    ],
                    navigation: {  
                        contractCreate: "Login",
                        LimitLogin: "LimitVerificationPhone"
                    },
                },            
            },
            {
                component: IdentificationSelectionView,
                name: "IdentificationSelection",
                path: "identification/start/:id",
                props: true,
                  meta: {
                    buttons: [
                    ],
                    navigation: {  
                        rekonoStart: "RekonoIdentificationStart",
                        rekonoSuccess: "RekonoIdentificationSuccess",
                        rekonoFail: "RekonoIdentificationFail"
                    },
                },  
            },
            {
                component: RekonoIdentificationStartView,
                name: "RekonoIdentificationStart",
                path: "identification/rekono/start/:id",
                props: true,
                meta: {
                    buttons: [
                    ],
                },  
            },
            {
                component: RekonoIdentificationView,
                name: "RekonoIdentification",
                path: "identification/rekono/check/:id",
                props: true,
                meta: {
                    buttons: [
                    ],
                    navigation: {  
                        rekonoSuccess: "RekonoIdentificationSuccess",
                        rekonoFail: "RekonoIdentificationFail"
                    },
                },  
            },
            {
                component: RekonoIdentificationFailView,
                name: "RekonoIdentificationFail",
                path: "identification/rekono/fail/:id",
                props: true,
                meta: {
                    buttons: [
                    ],
                },  
            },
            {
                component: RekonoIdentificationSuccessView,
                name: "RekonoIdentificationSuccess",
                path: "identification/rekono/success/:id",
                props: true,
                meta: {
                    buttons: [
                    ],
                },  
            },
            {
                component: PostIdentificationView,
                name: "IdentificationPost",
                path: "identification/post",
                meta: {
                    ipRestricted: true,
                    navigation: { 
                        endFail: "/StaticLoaders/ident_fail.html",
                        endSuccess: "IdentificationPostSuccess",
                        nextStep: "ProcessEndScreen"
                    },
                },  
            },
            {
                component: PostIdentificationSuccessView,
                name: "IdentificationPostSuccess",
                path: "identification/post/success",
                meta: {
                    ipRestricted: true,
                },  
            },
            {
                component: EmptyComponent,
                name: "PublicRoot",
                path: ":id",
            }
        ]
    }
];